module.exports = __webpack_public_path__ + "static/img/active-rule-title-bg.22fca18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active-rule-title-bg.png
// module id = GyHv
// module chunks = 0